import React, {Component} from 'react';

class RevLoan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: "",
            text: "",
            userdetail: {}
        }
        this.agreeCheck = this.agreeCheck.bind(this);

    }

    getValue(id) {
        fetch('http://localhost:3001/v1/revloan/${id}', {
            method: 'GET'
        })
            .then((response) => response.json())
            .then((result) => {
                console.log('Success:', result.message);
                this.setState({text: result})
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    agreeCheck(id) {
        fetch('http://localhost:3001/v1/revloan/${id}', {
            method: 'PUT',
            body: {}
        })
            .then((response) => response.json())
            .then((result) => {
                console.log('Success:', result.message);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    componentDidMount() {
        this.agreeCheck();
    }

    render() {
        return (
            <div>
                <div className="mainGridW">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="enterPa">
                                    <h3 className="newFontB">emergency Loan Agreement</h3>
                                    <div className="sater">

                                        <p>Borrower Name: {this.state.userdetail.name}</p>
                                        <p>Borrower PAN: {this.state.userdetail.pannumber}</p>
                                        <p>Borrower Email: {this.state.userdetail.phone}</p>
                                        <p>Borrower Mobile Number: {this.state.userdetail.email}</p>
                                        <p>Loan Amount: {this.state.userdetail.loanamount}</p>
                                        <p>Execution Date: {this.state.userdetail.interestrate}</p>
                                        <p>Interest Rate: {this.state.userdetail.emiamount}%</p>

                                        <div className="newPara">
                                            <br></br>
                                            <h4>By clicking “I Agree”, you hereby agree that,</h4>
                                            <ul>
                                                <li>
                                                    You have approached Aristo Securities Private Limited, a Non-
                                                    Banking Financial
                                                    Company having its registered office at 2nd Floor, E-Block
                                                    International Trade Tower, Nehru Place, New Delhi South Delhi DL
                                                    110019 IN and wholly owned subsidiary of Revfin Services Private
                                                    Limited (hereby referred to as ‘lender’) for a loan
                                                </li>
                                                <li>You have read and understood the terms of the loans as stated
                                                    above
                                                </li>
                                                <li>
                                                    In the event of default, the Lender shall be entitled to proceed
                                                    against and take any
                                                    action against the Borrower in order to realize the Loan Amount
                                                    along with Interest
                                                    and Usage Charges (if applicable), charges and expenses;
                                                </li>
                                                <li>
                                                    Event of default will be defined as any non-compliance by the
                                                    Borrower of the terms &
                                                    conditions of the loan or any other agreement entered into in
                                                    respect of this Loan or
                                                    any other financial assistance availed of by the Borrower from the
                                                    Lender; Non
                                                    adherence to the repayment of the Loan, Interest and any other
                                                    charges at the expiry
                                                    of the Term
                                                </li>
                                                <li>
                                                    The Borrower shall indemnify and hold the Lender and its directors,
                                                    officers,
                                                    employees, agents and advisers harmless against losses, claims,
                                                    liabilities, or damages
                                                    which are sustained as a result of any breach of the terms and
                                                    conditions of this
                                                    Agreement and/or any wilful fraud or concealment of information
                                                    relevant to the
                                                    transaction completed herein and/or Any representation and warranty
                                                    being found to
                                                    be untrue or false at a later date
                                                </li>
                                                <li>
                                                    This Agreement shall be governed and construed in accordance with
                                                    the Laws of
                                                    India and the Parties hereto submit to the exclusive jurisdiction of
                                                    the Courts of Delhi.
                                                </li>
                                            </ul>
                                            <p>
                                                If you do not agree, please do not continue to use this Website/Mobile
                                                Application or access
                                                any of its contents and are requested to immediately close/uninstall
                                                this Website/Mobile
                                                Application.
                                            </p>
                                            <div>
                                                <button className="colorVbtn"
                                                        onClick={() => this.agreeCheck(this.id)}> I Agree
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default RevLoan



// WEBPACK FOOTER //
// ./src/components/EmergencyLoan.js